import { render, staticRenderFns } from "./support.vue?vue&type=template&id=85026646"
import script from "./support.vue?vue&type=script&lang=js"
export * from "./support.vue?vue&type=script&lang=js"
import style0 from "./support.vue?vue&type=style&index=0&id=85026646&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports